<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('addEditOrdreTravailTech.caracterique.tache.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="card-article-any has-background-background has-text-centered"
               v-if="ordreTravail.taches.length === 0">
            <h1 class="title is-size-3 pdt-50px">
              {{ $t('addEditOrdreTravailTech.caracterique.tache.noTache')}}
            </h1>
          </div>
          <div v-else>
            <div class="columns">
              <div class="column is-1 has-text-default has-text-right">
                {{ $t('detailOrdreTravailTech.caracterique.tache.taches', {
                tacheRealise: getNumberTacheRealisees,
                tacheTotal: ordreTravail.taches.length,
              }) }}
              </div>
              <div class="column is-11 mgv-auto">
                <qd-progress type="is-primary"
                            :max="ordreTravail.taches.length"
                            :value="getNumberTacheRealisees"
                >
                </qd-progress>
              </div>
            </div>
          </div>
          <div v-for="(tache, index) in ordreTravail.taches"
               class="column is-12 pdt-0"
               :key="index">
            <div class="card mgt-20px">
              <div class="card-content">
                <div class="columns">
                  <div class="column is-10">
                    <p class="is-size-5 has-text-weight-bold has-text-link">
                      {{ tache.libelle }}
                    </p>
                    <p class="has-text-default">
                      {{ tache.description }}
                    </p>
                  </div>
                  <div class="column is-2 mgv-auto has-text-right">
                    <b-checkbox v-model="tache.realise"
                                :disabled="true"
                                type="is-primary">
                    </b-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LogistiqueOrdreTravailTechniqueDetailCaractéristiqueTaches',
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getNumberTacheRealisees() {
      return this.ordreTravail.taches.filter((tache) => {
        return tache.realise;
      }).length;
    },
  },
};

</script>
